import withCollegeService from '../withCollegeService';
import { GraduationRate4year, GraduationRate6year } from './graduationRate';
import StudentRetention from './studentRetention';
import StudyOptions from '../services';
import TopAreasOfStudy from './topAreasOfStudy';

export const GraduationRate4Component = withCollegeService(
  GraduationRate4year,
  'studies.field_he_gradratebachelors4yrs',
  {},
  {
    value: 'field_he_gradratebachelors4yrs',
  },
);

export const GraduationRate6Component = withCollegeService(
  GraduationRate6year,
  'studies.field_he_gradratebachelors6yrs',
  {},
  {
    value: 'field_he_gradratebachelors6yrs',
  },
);

export const StudentRetentionComponent = withCollegeService(
  StudentRetention,
  'studies.studentRetention',
  {},
  {
    value: 'field_he_retentionratefulltime',
  },
);

export const StudyOptionsComponent = withCollegeService(
  StudyOptions,
  'studies.studyOptions',
  {},
  {
    studyAbroadCredit: 'field_he_special_services_id_ref',
    studyAbroadNonCredit: 'field_he_special_services_id_ref',
    graduateStudyAbroadCredit: 'field_he_special_services_id_ref',
    graduateStudyAbroadNonCredit: 'field_he_special_services_id_ref',
    studyAbroad: 'field_he_special_services_id_ref',
    graduateStudyAbroad: 'field_he_special_services_id_ref',
    teacherCertificationPrograms: 'field_he_teachercertpgms',
    combinedDegreePrograms: 'field_he_combineddegreepgms',
    domesticStudyAwayPrograms: 'field_he_domstudyawaypgms',
    weekendEveningPrograms: 'field_he_weekendeveningpgms',
    acceleratedProgram: 'field_he_acceleratedprogram',
    doubleMajor: 'field_he_doublemajor',
    externalDegreeProgram: 'field_he_externaldegreeprogram',
    honorsProgram: 'field_he_honorsprogram',
    independentStudy: 'field_he_independentstudy',
    internships: 'field_he_internships',
    weekendCollege: 'field_he_weekendcollege',
    cooperativeEducationPrograms: 'field_he_cooperativeedupgms',
  },
);

export const TopAreasOfStudyComponent = withCollegeService(
  TopAreasOfStudy,
  'studies.topAreasOfStudy',
  {},
  {
    1: 'field_he_popularareaofstudy1',
    2: 'field_he_popularareaofstudy2',
    3: 'field_he_popularareaofstudy3',
    4: 'field_he_popularareaofstudy4',
    5: 'field_he_popularareaofstudy5',
  },
);

export {
  GraduationRate4Component as GraduationRate4,
  GraduationRate6Component as GraduationRate6,
  StudentRetentionComponent as StudentRetention,
  StudyOptionsComponent as StudyOptions,
  TopAreasOfStudyComponent as TopAreasOfStudy,
};
